import { render, staticRenderFns } from "./catalogoDiagnostico.vue?vue&type=template&id=4030f3a5&"
import script from "./catalogoDiagnostico.vue?vue&type=script&lang=js&"
export * from "./catalogoDiagnostico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports